import { render, staticRenderFns } from "./EmailTemplate.vue?vue&type=template&id=b548d932&scoped=true&"
import script from "./EmailTemplate.vue?vue&type=script&lang=js&"
export * from "./EmailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplate.vue?vue&type=style&index=0&id=b548d932&prod&lang=scss&"
import style1 from "./EmailTemplate.vue?vue&type=style&index=1&id=b548d932&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b548d932",
  null
  
)

export default component.exports